export const SUPPORTED_VACCINE_SCHEMA_VERSION = 2
export const SUPPORTED_VACCINE_RULE_ENGINE_VERSION = 1

export const VACCINE_V2_DEFINITIONS_PATH = 'vaccineSchemas/v2/definitions'
